import type { Package } from '@/integrations/revenuecat/types';
import { isPurchaseCancelledError } from '@/integrations/revenuecat/utils/isPurchaseCancelledError';
import { purchasePackage } from '@/integrations/revenuecat/utils/purchasePackage';

export type SubscribeResult =
  | { outcome: 'subscribed' }
  | { outcome: 'cancelled' };

export class SubscriptionError extends Error {
  constructor(
    message: string,
    public readonly cause?: unknown,
  ) {
    super(message);
    this.name = 'SubscriptionError';
  }
}

export async function subscribe(
  targetPackage: Package,
): Promise<SubscribeResult> {
  try {
    await purchasePackage(targetPackage);
    return { outcome: 'subscribed' };
  } catch (error) {
    if (isPurchaseCancelledError(error)) {
      return { outcome: 'cancelled' };
    }
    throw new SubscriptionError('Failed to complete purchase', error);
  }
}
